<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">                
                <FormRow>
                  <input type="checkbox" @click="setValue('custom.noAttend', !noAttend)" :checked="noAttend" id="noAttend" class="checkbox-input"/>  <FormLabel for="noAttend"> I cannot attend but I would like to make a donation in honor of the Zula / Zvi Sand</FormLabel>
                </FormRow>                
                <FormSection v-if=!form.custom.noAttend>
                    <FormRow inline>      
                        <LazyCurrencySelector :currencies="['ILS','USD','CAD']"/>
                    </FormRow>    
                    <FormRow class="note">
                      Purchase Single Tickets (500 NIS / $140 USD / $190 CAD per ticket).
                    </FormRow>   
                    <FormRow>
                      <OuisraelTubshvatAmounts />
                    </FormRow>      
                    <FormRow class="note">
                      Or Make a Sponsorship
                    </FormRow>                              
                    <FormRow>
                      <AmountSelectorList />                    
                      <ErrorLabel field="amount" />                      
                    </FormRow>
                    <p class="disclaimer">
                      * Tickets can only be purchased by clicking on the Purchase Single Ticket option above. Amounts entered in the Other Amount Option will not count towards the purchase of a ticket.
                    </p>         
                    <FormRow>
                      <input type="checkbox" @click="setValue('custom.transportation', !transportation)" :checked="transportation" id="transportation" class="checkbox-input"/>                      
                      <FormLabel for="transportation"> I need arranged transportation to the event</FormLabel>
                    </FormRow>         
                </FormSection>
                <FormSection v-if="form.custom.noAttend">
                  <FormRow inline>      
                      <LazyCurrencySelector :currencies="['ILS','USD','CAD']"/>
                  </FormRow> 
                  <FormRow>
                    <OuisraelTubshvatAmountSelectorList />                    
                    <ErrorLabel field="amountAlt" />                                          
                  </FormRow>
                  <InHonorOfTubshvat />  
                </FormSection>
                <FormSection>
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>   
                    <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>                                      
                </FormSection>                
                <FormSection last>
                    <DonorAddress />
                </FormSection>
                    <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
	  const { getValue, setValue, form } = usePaymentForm()
	  const noAttend = computed(() => getValue('custom.noAttend'))
	  const transportation = computed(() => getValue('custom.transportation'))

	  return {
			form,
      noAttend,
      transportation,
			setValue,
			getValue
	  }
  }
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
.note {
  margin: 20px 0;
  font-size: 15px;
  color: #333;
  font-weight: 600;
}
.disclaimer {
  margin: 20px 0;
  font-size: 13px;
  line-height: 1.4;
  color: #575757;
  background: #f7f7f7;
  padding: 10px 20px;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.checkbox-input {
  margin-right: 5px;
}
</style>

